import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../../Layouts/Layout";
import Typography from "@mui/material/Typography";
import Section from "@/src/components/Section/Section";
import Container from "@/src/components/Container/Container";
import imgContact from "@/src/assets/img/teaser/contact/contact.svg";
import { Box, Button, Paper } from "@mui/material";
import imgContactMobile from "@/src/assets/img/teaser/contact/contact-mobile.svg";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import contactPageStyle from "@/src/containers/Pages/Generic/ContactPage/contactPageStyle";
import { useAuthDialog } from "@/src/provider/AuthDialog/AuthDialogProvider";
import LogoBird from "@/src/components/Logo/LogoBird";
import { mergeSx } from "@/src/utils/mergeSx";
import LinkLegalbird from "@/src/components/legalbird/LinkLegalbird/LinkLegalbird";
import { Link } from "react-router";
import HeadlineSection from "@/src/components/Sections/Generic/HeadlineSection/HeadlineSection";

export default function ContactPage() {
  const title = "Kontakt | Legalbird";
  const theme = useTheme();
  const { setView } = useAuthDialog();

  return (
    <Layout backgroundType={"landingpage"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Section>
        <Container variant={"sm"}>
          <HeadlineSection headline={"Ihr Kontakt zu uns"} />
          <Typography sx={{ padding: 0, textAlign: { xs: "left", md: "center" } }}>
            Sie brauchen unsere Hilfe oder möchten mit uns zusammenarbeiten? Wir freuen uns über Ihre Nachricht!
          </Typography>
        </Container>

        <Container variant={"xl"}>
          <Paper elevation={0} sx={mergeSx(contactPageStyle.paper, { padding: { xs: "1rem", md: "4rem" } })}>
            <Grid container spacing={4}>
              <Grid size={{ xs: 12, md: 6 }} sx={contactPageStyle.textSection}>
                <Typography variant={"h5"} component={"h2"}>
                  Ihre persönliche Servicewelt
                </Typography>
                <Typography>
                  <strong>Sie haben schon einen Fall bei uns?</strong> Dann finden Sie in Ihrer Servicewelt alles rund um Ihren Fall und können uns dort
                  jederzeit ganz unkompliziert eine Nachricht schreiben oder uns Dokumente zukommen lassen.
                </Typography>
                <Button variant={"contained"} sx={{ marginTop: "3rem", width: "14re" }} onClick={() => setView({ type: "login" })}>
                  Zu Ihrer Servicewelt
                </Button>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }} sx={{ paddingTop: { xs: "2rem" } }}>
                <picture>
                  <source media={`(min-width: ${theme.breakpoints.values.md}px)`} srcSet={imgContact} width="608" height="375" />
                  <Box component="img" src={imgContactMobile} sx={{ height: "auto" }} width="312" height="349" />
                </picture>
              </Grid>
            </Grid>
          </Paper>
        </Container>

        <Container variant={"xl"}>
          <Paper elevation={0} sx={contactPageStyle.paper}>
            <Grid container spacing={4} sx={{ overflow: "hidden" }}>
              <Grid size={{ xs: 12, md: 6 }} sx={contactPageStyle.logoWrapper}>
                <LogoBird sx={contactPageStyle.logoBird} />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }} sx={mergeSx(contactPageStyle.textSection, { padding: { xs: "1rem", md: 0 } })}>
                <Typography variant={"h5"} component={"h2"}>
                  Mit Legalbird zusammenarbeiten
                </Typography>
                <Typography>
                  <strong>Sie sind an einer Zusammenarbeit mit einer innovativen und professionellen Kanzlei interessiert?</strong> Dann melden Sie sich gerne
                  per E-Mail bei uns.
                </Typography>
                <Button
                  variant={"contained"}
                  sx={{ marginTop: "3rem", width: "15rem" }}
                  component={Link}
                  to={"mailto:partnership@legalbird.de?subject=Anfrage:%20Zusammenarbeit%20mit%20Legalbird"}
                >
                  Kooperation anfragen
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Container>

        <Container variant={"sm"} sx={{ textAlign: "center" }}>
          <Typography variant={"h5"} component={"h2"}>
            Sie haben noch gar keinen Fall bei uns, sondern
            <br /> nur allgemeine Fragen zum Ablauf?
          </Typography>
          <Typography>
            Dann schicken Sie uns gerne eine <LinkLegalbird to={"mailto:service@legalbird.de"}>E-Mail</LinkLegalbird>
          </Typography>
        </Container>
      </Section>
    </Layout>
  );
}
